import { render, staticRenderFns } from "./VehiclesSection.vue?vue&type=template&id=c6d2bdea&scoped=true"
import script from "./VehiclesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehiclesSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VehiclesSection.vue?vue&type=style&index=0&id=c6d2bdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2bdea",
  null
  
)

export default component.exports